export const env = {
  kenticoAssetURL: process.env.kenticoAssetURL,
  clientId: process.env.clientId,
  clientSecret: process.env.clientSecret,
  credstoreKongUtilsServiceBasicAuthToken:
    process.env.credstoreKongUtilsServiceBasicAuthToken,
  hcidExtrnalApiBaseUrl: process.env.hcidExtrnalApiBaseUrl,
  kongBasicAuthToken: process.env.kongBasicAuthToken,
  MAGNOLIA_URL: process.env.MAGNOLIA_URL,
  BASE_MAGNOLIA_REST_URL: process.env.BASE_MAGNOLIA_REST_URL,
  BASE_MAGNOLIA_IMAGING_URL: process.env.BASE_MAGNOLIA_IMAGING_URL,
  baseUrl: process.env.baseUrl,
};
